import {
    type GetNewsDetailRequestType,
    type GetNewsDetailResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetNewsDetail = async (params: GetNewsDetailRequestType): Promise<GetNewsDetailResponseType> => {
    return await axios(`${SERVER_ADDRESS}/front/getNewsDetail`, {
        method: "GET",
        headers: getHeaders(),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetNewsDetail;
